import React, { useState } from 'react';
import { Box, Typography, Drawer } from '@mui/material';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';

import Slidemenu from '../../components/admin/adminSlidemenu.tsx';
import AdminHeader from '../../components/admin/adminHeader.tsx';

const PickupMessage: React.FC = () => {
  const [paragraph, setParagraph] = useState(''); // State for the paragraph Content
  const [mobileOpen, setMobileOpen] = useState(false); // State for mobile menu

  const handleToggleMenu = () => {
    setMobileOpen(prev => !prev);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      {/* Main container: Sidebar + Content */}
      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {/* Sidebar for desktop */}
        <Box sx={{ width: 250, flexShrink: 0, display: { xs: 'none', md: 'block' } }}>
          <Slidemenu mobileOpen={false} onToggle={function (): void {
                      throw new Error('Function not implemented.');
                  } } />
        </Box>

        {/* Drawer for mobile */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleToggleMenu}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': { width: 250 },
          }}
        >
          <Slidemenu mobileOpen={false} onToggle={function (): void {
                      throw new Error('Function not implemented.');
                  } } />
        </Drawer>

        {/* Main content area */}
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          {/* Header with menu toggle button */}
          <AdminHeader onToggleMenu={handleToggleMenu} />

          {/* Content */}
          <Box
            sx={{
              flexGrow: 1,
              overflow: 'auto',
              p: 2,
              backgroundColor: '#f5f5f5',
            }}
          >
            {/* Pickup Date Message Box */}
            <Box
              sx={{
                mb: 3,
                p: 2,
                backgroundColor: '#fff',
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Typography variant="h6" gutterBottom>
                Pickup Date Message
              </Typography>
              <ReactQuill
                theme="snow"
                value={paragraph}
                onChange={setParagraph}
                placeholder="Add pickup date message..."
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PickupMessage;